module.exports = __webpack_public_path__ + "static/img/ie@2x.238a038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/ie@2x.png
// module id = kz8c
// module chunks = 1